/* ============================================================
   HOUSE OF PARVI — COLLECTION GRID
   V132: CSS-only crossfade (rAF+lerp removed), dark hero particles,
         cursor vignette, reveal IO, facet filter, sort enhancer.
   No loops forever. One IO per behaviour (reveal, canvas-pause).
   prefers-reduced-motion gated throughout.
============================================================ */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverCapable  = window.matchMedia('(hover: hover)').matches;

  // ── Reveal IO ────────────────────────────────────────────
  // One IO, threshold 0.12. Adds .is-in, stagger per row, unobserves.
  var revealIO = new IntersectionObserver(function (entries) {
    var colCount = getColCount();
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var idx = parseInt(el.dataset.revealIdx, 10) || 0;
      var rowPos = idx % colCount;
      if (!reducedMotion) {
        el.style.transitionDelay = (rowPos * 70) + 'ms';
      }
      el.classList.add('is-in');
      el.classList.add('on'); // also satisfy base.css .r.on rule
      revealIO.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function getColCount() {
    var w = window.innerWidth;
    if (w <= 768)  return 1;
    if (w <= 1100) return 2;
    return 3; // default; adjusts if coll-grid--2 or --4 but keep simple
  }

  function observeCards(nodeList) {
    nodeList.forEach(function (el, i) {
      el.dataset.revealIdx = i;
      revealIO.observe(el);
    });
  }

  // ── Cursor gold vignette ─────────────────────────────────
  var vignette = null;
  var vigX = 0, vigY = 0;
  var vigRafId = null;

  function initVignette(gridEl) {
    if (!hoverCapable || reducedMotion) return;
    vignette = document.querySelector('.coll-vignette');
    if (!vignette) return;

    gridEl.addEventListener('mousemove', function (e) {
      vigX = e.clientX - 350;
      vigY = e.clientY - 350;
      if (!vigRafId) {
        vigRafId = requestAnimationFrame(moveVignette);
      }
      if (!vignette.classList.contains('is-active')) {
        vignette.classList.add('is-active');
      }
    }, { passive: true });

    gridEl.addEventListener('mouseleave', function () {
      vignette.classList.remove('is-active');
    }, { passive: true });
  }

  function moveVignette() {
    vigRafId = null;
    if (vignette) {
      vignette.style.transform = 'translate3d(' + vigX + 'px,' + vigY + 'px,0)';
    }
  }

  // ── Facet filter ─────────────────────────────────────────
  function initFacets(gridEl, countEl) {
    var chips = Array.from(document.querySelectorAll('.coll-facet-chip'));
    var clearBtn = document.querySelector('.coll-facet-clear');
    if (!chips.length) return;

    // Restore from sessionStorage
    var stored = sessionStorage.getItem('hopFacets');
    if (stored) {
      try {
        var active = JSON.parse(stored);
        chips.forEach(function (chip) {
          var key = chip.dataset.facetType + ':' + chip.dataset.facetValue;
          if (active.indexOf(key) !== -1) chip.dataset.active = 'true';
        });
      } catch(e) { /* ignore */ }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var isActive = this.dataset.active === 'true';
        this.dataset.active = isActive ? 'false' : 'true';
        applyFacets();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        chips.forEach(function (c) { c.dataset.active = 'false'; });
        applyFacets();
      });
    }

    function applyFacets() {
      var activeByType = {};
      chips.forEach(function (chip) {
        if (chip.dataset.active === 'true') {
          var t = chip.dataset.facetType;
          if (!activeByType[t]) activeByType[t] = [];
          activeByType[t].push(chip.dataset.facetValue);
        }
      });

      var hasActive = Object.keys(activeByType).length > 0;
      if (clearBtn) clearBtn.classList.toggle('is-visible', hasActive);

      // Persist
      var allActive = [];
      chips.forEach(function (chip) {
        if (chip.dataset.active === 'true') {
          allActive.push(chip.dataset.facetType + ':' + chip.dataset.facetValue);
        }
      });
      sessionStorage.setItem('hopFacets', JSON.stringify(allActive));

      var pcards = Array.from(gridEl.querySelectorAll('.pcard[data-sizes]'));
      var visible = 0;

      pcards.forEach(function (card) {
        var show = true;

        if (activeByType.size) {
          var sizes = (card.dataset.sizes || '').split(',');
          var match = activeByType.size.some(function (s) {
            return sizes.indexOf(s) !== -1;
          });
          if (!match) show = false;
        }

        if (activeByType.availability) {
          var avail = card.dataset.availability || '';
          if (activeByType.availability.indexOf(avail) === -1) show = false;
        }

        if (activeByType.price) {
          var band = card.dataset.priceBand || '';
          if (activeByType.price.indexOf(band) === -1) show = false;
        }

        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (countEl) {
        var total = hasActive ? visible : pcards.length;
        countEl.textContent = total + ' piece' + (total !== 1 ? 's' : '');
      }
    }

    // Apply on load in case sessionStorage restored active chips
    applyFacets();
  }

  // ── Load More ────────────────────────────────────────────
  function initLoadMore() {
    var btn = document.getElementById('coll-load-more');
    if (!btn) return;

    var currentPage  = 1;
    var totalPages   = parseInt(btn.dataset.totalPages, 10) || 1;
    var gridEl       = document.querySelector('.coll-grid');
    if (!gridEl) return;

    btn.addEventListener('click', function () {
      if (btn.classList.contains('coll-load-more--loading')) return;
      currentPage++;
      btn.classList.add('coll-load-more--loading');
      btn.textContent = 'Loading\u2026';

      // Was: pathname + '?page=N' + location.search.replace(...) — location.search still starts
      // with '?', so the fetched URL became "?page=2?sort_by=..." (malformed). (Task 2)
      var params = new URLSearchParams(window.location.search);
      params.set('page', String(currentPage));
      var url = window.location.pathname + '?' + params.toString();

      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.coll-grid');
          if (!newGrid) return;

          var newCards = Array.from(newGrid.querySelectorAll('.pcard'));
          var startIdx = gridEl.querySelectorAll('.pcard').length;

          newCards.forEach(function (card, i) {
            card.dataset.revealIdx = startIdx + i;
            gridEl.appendChild(card);
            revealIO.observe(card);
          });

          btn.classList.remove('coll-load-more--loading');

          if (currentPage >= totalPages) {
            btn.classList.add('coll-load-more--done');
            btn.textContent = 'All pieces shown';
          } else {
            var shown = gridEl.querySelectorAll('.pcard').length;
            var total = parseInt(btn.dataset.total, 10) || 0;
            btn.textContent = 'Load more \u2014 showing ' + shown + ' of ' + total + ' pieces';
          }
        })
        .catch(function () {
          btn.classList.remove('coll-load-more--loading');
          btn.textContent = 'Try again';
          currentPage--;
        });
    });
  }

  // ── Hero particle canvas ─────────────────────────────────
  function initHeroParticles() {
    if (reducedMotion) return;
    var canvas = document.getElementById('coll-particles');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var rafId = null;
    var pts = [];

    function resize() {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      pts = [];
      for (var i = 0; i < 22; i++) {
        pts.push({
          x:  Math.random() * canvas.width,
          y:  Math.random() * canvas.height,
          r:  Math.random() * 1.4 + 0.4,
          vx: (Math.random() - 0.5) * 0.28,
          vy: (Math.random() - 0.5) * 0.28,
          o:  Math.random() * 0.28 + 0.04
        });
      }
    }

    function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pts.forEach(function (p) {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(245,242,236,' + p.o + ')';
        ctx.fill();
      });
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId == null) rafId = requestAnimationFrame(tick);
    }
    function stop() {
      if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
    }

    resize();
    if (!document.hidden) start();
    window.addEventListener('resize', resize, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Pause when hero scrolls out of view (Rule 6: nothing loops forever)
    var pauseIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) start(); else stop();
      });
    }, { threshold: 0 });
    pauseIO.observe(canvas);
  }

  // ── Filter/Sort toggle buttons — independent, collapsed by default (Task 1c) ──
  // openIfSelector: if a restored sessionStorage facet is active on load, open the
  // Filter panel so the visitor can SEE why the grid is filtered (correction vs the
  // original plan — otherwise a stored facet silently filters a collapsed panel).
  function initPanelToggle(btnId, panelId, openIfSelector) {
    var btn = document.getElementById(btnId);
    var panel = document.getElementById(panelId);
    if (!btn || !panel) return;
    if (openIfSelector && document.querySelector(openIfSelector)) {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  }

  // ── Hero title auto-fit ──────────────────────────────────────────
  // A long single word (e.g. "REMINISCENCE") has no space to wrap at, so at a
  // narrow viewport it can be wider than the title's box and run past the
  // edge instead of wrapping. Rather than hardcode a smaller clamp() bound
  // (which only ever suits the titles tested, not the ones typed later),
  // measure the rendered title and step its font-size down until it fits —
  // works for any collection/search title, at any viewport width.
  function fitHeroTitle(el) {
    if (!el) return;
    el.style.fontSize = '';   // reset to the CSS clamp() value before measuring
    var minSize = 28;         // legibility floor — never shrink past this
    var guard = 0;
    var size = parseFloat(getComputedStyle(el).fontSize);
    while (el.scrollWidth > el.clientWidth + 1 && size > minSize && guard < 60) {
      size -= 1;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }
  function fitAllHeroTitles() {
    document.querySelectorAll('.coll-hero-title').forEach(fitHeroTitle);
  }

  // ── Init ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var collPage = document.querySelector('.coll-page');
    if (!collPage) return;

    var gridEl   = collPage.querySelector('.coll-grid');
    var countEl  = collPage.querySelector('.coll-count');
    var allCards = Array.from(collPage.querySelectorAll('.pcard'));

    // Wire reveal IO
    observeCards(allCards);

    // Cursor vignette
    if (gridEl) initVignette(gridEl);

    // Facet filter
    if (gridEl && countEl) initFacets(gridEl, countEl);

    // Load More
    initLoadMore();

    // Hero particles
    initHeroParticles();

    // Filter/Sort collapsible toggles — independent of each other (Task 1c)
    initPanelToggle('coll-filter-toggle', 'coll-facets-panel', '.coll-facet-chip[data-active="true"]');
    initPanelToggle('coll-sort-toggle', 'coll-sort-panel');

    // Hero title auto-fit — re-run once web fonts swap in (serif metrics differ
    // from the fallback used for the first measurement) and on resize/rotate.
    fitAllHeroTitles();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAllHeroTitles);
    }
    var heroFitResizeTimer = null;
    window.addEventListener('resize', function () {
      if (heroFitResizeTimer) clearTimeout(heroFitResizeTimer);
      heroFitResizeTimer = setTimeout(fitAllHeroTitles, 150);
    }, { passive: true });
  });

})();
